import React from 'react';

export const SkipNavigation: React.FC = () => {
  return (
    <a href="#main-content" className="skip-nav">
      Skip to main content
    </a>
  );
};
